import { motion } from "framer-motion";
import { drift } from "./motionpresets";

export default function DriftingGlow({
  className = "bg-sky-200/50",
  size = 420,
  style,
  dx = [0, 10, -10, 0],
  dy = [0, 10, -6, 0],
  duration = 14,
  ...rest
}) {
  const anim = drift({ dx, dy, duration });
  return (
    <motion.div
      {...anim}
      className={`pointer-events-none rounded-full blur-3xl ${className}`}
      style={{ width: size, height: size, ...style }}
      {...rest}
    />
  );
}
